import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Button, Input } from "reactstrap";
import { toast } from "react-toastify";
import { Formik, Form, ErrorMessage } from "formik";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { register } from "../../../context/actions/user";
import { signUpSchema, signUpInit } from "./schema";
import TextInput from "../../common/FormsInput/FormInput";
import Head from "../Head";
import './../SignupModule.scss';
import { Link } from "react-router-dom";
toast.configure();

const SignUp = () => {
	localStorage.removeItem("_expiredTime");

	const dispatch = useDispatch();
	const [passwordType, setPasswordType] = useState("password");
	const [confirmpasswordType, setconfirmPasswordType] = useState("password");
	const [disabled, setDisabled] = useState(false);
	/**
	 * @description method call to submit valid form
	 * @param {Object} params form params
	 * @param {Instance} status form status
	 */
	const submitForm = async (params, status) => {
		// update payload
		params.email = params.email.toLowerCase();
		params.name = params.fname + " " + params.lname;
		params.role = "business";
		// End
		setDisabled(true);
		dispatch(
			register(params, (result) => {
				setDisabled(false);
			})
		);
	};


	/**
	* @togglePassword method call to submit valid form
	*/

	const togglePassword = () => {
		if (passwordType === "password") {
			setPasswordType("text")
			return;
		}
		setPasswordType("password")
	}

	/**
	* @toggleconfirmPassword method call to submit valid form
	*/

	const toggleconfirmPassword = () => {
		if (confirmpasswordType === "password") {
			setconfirmPasswordType("text")
			return;
		}
		setconfirmPasswordType("password")
	}

	return (
		<div className={`login-blc m-auto signup-box`}>
			<Head heading="Welcome! Please signup to continue." className="signup-page" />
			<div className="already-account">
				Already a member? <Link to="/login" color="link">Sign In</Link>
			</div>
			<Formik
				initialValues={signUpInit}
				enableReinitialize
				validationSchema={signUpSchema}
				onSubmit={submitForm}
			>
				{(formik) => (<Form >
					<TextInput
						name="email"
						placeholder="Enter your email"
						value={formik?.values?.email}
						onChange={formik.handleChange}
						isRequired={true}
						label="Email Address"
					/>
					<TextInput
						name="password"
						type={passwordType}
						placeholder="Enter your password"
						id="newPassword"
						value={formik?.values?.password}
						isRequired={true}
						label="Password"
						onChange={formik.handleChange}
						isIcon
						togglePassword={togglePassword}
						passwordType={passwordType}
						passwordHint
					/>

					<TextInput
						type={confirmpasswordType}
						name="confirmPassword"
						placeholder="Confirm Password"
						id="confirmPassword"
						label="Confirm Password"
						isRequired={true}
						value={formik?.values?.confirmPassword}
						onChange={formik.handleChange}
						isIcon
						togglePassword={toggleconfirmPassword}
						passwordType={confirmpasswordType}
					/>

					<TextInput
						name="fname"
						type="text"
						placeholder="Enter your first name"
						value={formik?.values?.fname}
						onChange={formik.handleChange}
						label="First Name"
						isRequired={true}
					/>
					<TextInput
						name="lname"
						type="text"
						placeholder="Enter your last Name"
						value={formik?.values?.lname}
						onChange={formik.handleChange}
						label="Last Name"
						id={"lastname"}
					/>
					<TextInput
						name="orgName"
						type="text"
						placeholder="Enter your organization name"
						value={formik?.values?.orgName}
						onChange={formik.handleChange}
						isRequired={true}
						label="Organization Name"
						id={"organization"}
					/>
					<div className="term-blc">
						<label className={`d-flex ${formik.errors.acceptTerms && formik.touched.acceptTerms ? 'is-invalid' : ''}`}>
							<span className="checkbox-blc position-relative">
								<Input
									type="checkbox"
									className="position-absolute"
									name="acceptTerms"
									onChange={(e) => { formik.setFieldValue('acceptTerms', e.target.checked); }}
								/>
								<span className="icon-box d-inline-flex align-items-center justify-content-center">
									<span className="icon d-inline-flex">
										<FontAwesomeIcon icon={faCheck} />
									</span>
								</span>
							</span>
							<span>
								By clicking <strong>Create Account</strong> below, you agree to
								our terms of service and privacy statement.
							</span>
						</label>
						<ErrorMessage name="acceptTerms" component="div" className="invalid-feedback w-100" />
					</div>
					<div className="btn-cell d-flex">
						<Button disabled={disabled} className="flex-fill" color="primary" >
							Create Account
						</Button>
					</div>
				</Form>)}
			</Formik>
		</div>
	);
};

export default SignUp;
